// Where to come back to after connecting a social account. GitHub drops the state when the person only updates
// the installation of its app, so the tab keeps it too.
const storageKey = 'fransys_social_account_return_state'

export function rememberSocialAccountReturnState(state: string): void {
  try {
    window.sessionStorage.setItem(storageKey, state)
  } catch {
    // Without storage, the state the provider sends back still applies.
  }
}

export function rememberedSocialAccountReturnState(): string | undefined {
  try {
    return window.sessionStorage.getItem(storageKey) ?? undefined
  } catch {
    return undefined
  }
}

export function forgetSocialAccountReturnState(): void {
  try {
    window.sessionStorage.removeItem(storageKey)
  } catch {
    // Nothing was kept.
  }
}
